import { render, staticRenderFns } from "./PhoneLogin.vue?vue&type=template&id=21a03fce&scoped=true"
import script from "./PhoneLogin.vue?vue&type=script&lang=js"
export * from "./PhoneLogin.vue?vue&type=script&lang=js"
import style0 from "./PhoneLogin.vue?vue&type=style&index=0&id=21a03fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a03fce",
  null
  
)

export default component.exports